// Type: Service


import API from "../../helpers/network/http";
import {Config, OmniSearchResult} from "../../utils/types";
import {normalizeLocale} from "../../i18n/locale";

export default class GlobalService {
    // Get app config
    static async getConfig(): Promise<Config> {
        // Call the register endpoint from the API
        const {data} = await API.get("/config");

        // Return the response
        return data.data;
    }

    static async getPreferredCurrency(): Promise<string | null> {
        const {data} = await API.get('/config/user');
        const preferred = data?.data?.preferred_currency || data?.data?.preference?.preferred_currency || null;
        return preferred ? String(preferred).toUpperCase() : null;
    }

    static async updatePreferredCurrency(preferredCurrency: string): Promise<string | null> {
        const code = String(preferredCurrency || '').trim().toUpperCase();
        const {data} = await API.put('/config/user', {
            preferred_currency: code || null,
        });
        const preferred = data?.data?.preferred_currency || data?.data?.preferences?.preferred_currency || null;
        return preferred ? String(preferred).toUpperCase() : null;
    }

    static async getPreferredLanguage(): Promise<string | null> {
        const {data} = await API.get('/config/user');
        const preferred = data?.data?.preferences?.language || data?.data?.preference?.language || null;
        return preferred ? normalizeLocale(String(preferred)) : null;
    }

    static async updatePreferredLanguage(language: string): Promise<string | null> {
        const normalized = normalizeLocale(language);
        const {data} = await API.put('/config/user', {
            preferences: {
                language: normalized,
            },
        });
        const preferred = data?.data?.preferences?.language || data?.data?.preference?.language || null;
        return preferred ? normalizeLocale(String(preferred)) : null;
    }

    static async getLoginOtpEnabled(): Promise<boolean> {
        const {data} = await API.get('/config/user');
        const value = data?.data?.login_otp_enabled
            ?? data?.data?.preference?.security?.login_otp_enabled
            ?? data?.data?.preferences?.security?.login_otp_enabled
            ?? false;
        return Boolean(value);
    }

    static async updateLoginOtpEnabled(enabled: boolean): Promise<boolean> {
        const {data} = await API.put('/config/user', {
            login_otp_enabled: Boolean(enabled),
        });
        const value = data?.data?.login_otp_enabled
            ?? data?.data?.preferences?.security?.login_otp_enabled
            ?? false;
        return Boolean(value);
    }

    // OmniSearch
    static async omniSearch(query: any): Promise<OmniSearchResult> {
        console.log("OmniSearch Query:", query);
        const { data } = await API.get(`/search/omni`, {
            params: {
                query: query.query,
                limit_songs: query.limit_songs || 6,
                page_songs: query.page_songs || 1,
                limit_artists: query.limit_artists || 3,
                page_artists: query.page_artists || 1,
                limit_albums: query.limit_albums || 4,
                page_albums: query.page_albums || 2,
                limit_community_contributions: query.limit_community_contributions || 2,
                page_community_contributions: query.page_community_contributions || 1
            }
        });
        return data.data;
    }
}
